import { freddyTheme, mapToStyles, mergeStyles, } from '@coolblue-development/freddy';
function orientationStyles(orientation, sliceCount) {
    return {
        vertical: {
            gridTemplateColumns: '1fr',
            gridRow: `span ${sliceCount}`,
            '& > *': {
                gridColumn: 1,
                minHeight: 0,
                height: '100%',
                '&:first-of-type': {
                    gridRow: 'initial',
                },
            },
        },
        horizontal: {
            gridTemplateColumns: '4fr 8fr',
            gridRow: `span ${sliceCount - 1}`,
            '& > *': {
                gridColumn: 2,
                '&:first-of-type': {
                    gridColumn: 1,
                    gridRow: '1 / -1',
                },
            },
        },
    }[orientation];
}
const gridChildStyles = {
    true: {
        gridTemplateRows: 'subgrid',
    },
    false: {
        gridTemplateRows: 'auto',
    },
};
const withBorderStyles = {
    true: {
        border: `${freddyTheme.borderWidth[25]} solid ${freddyTheme.color.border.base}`,
        padding: freddyTheme.spacing[400],
    },
    false: {
        border: 'none',
        padding: 0,
    },
};
function getOrientationStyles(orientationValue = 'vertical', sliceCount) {
    const resolveOrientation = (orientation) => ({
        ...orientationStyles(orientation, sliceCount),
    });
    return mapToStyles(orientationValue, resolveOrientation, 'vertical');
}
function getGridChildStyles(gridChild = false) {
    const resolveGridChild = (isGridChild) => ({
        ...gridChildStyles[String(isGridChild)],
    });
    return mapToStyles(gridChild, resolveGridChild, false);
}
function getWithBorderStyles(withBorder = false) {
    const resolveWithBorder = (isWithBorder) => ({
        ...withBorderStyles[String(isWithBorder)],
    });
    return mapToStyles(withBorder, resolveWithBorder, false);
}
export const getGenericProductCardStyles = ({ gridChild = false, orientation = 'vertical', withBorder = false, sliceCount = 6, }) => mergeStyles([
    {
        height: '100%',
        borderRadius: freddyTheme.borderRadius[100],
    },
    getOrientationStyles(orientation, sliceCount),
    getGridChildStyles(gridChild),
    getWithBorderStyles(withBorder),
]);
//# sourceMappingURL=GenericProductCard.styles.js.map